import React from 'react';

function ScheduleControl({ 
  viewMode, 
  selectedDate, 
  currentSchedules, 
  onOpenModal, 
  onDeleteSelected, 
  onToggleComplete, 
  onDeleteSchedule 
}) {
  return (
    <div style={{ 
      width: '100%',
      maxWidth: '350px',
      minWidth: '300px',
      backgroundColor: '#F9F9F9',
      padding: '25px',
      borderRadius: '12px',
      border: '1px solid #E2E2E2',
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      boxSizing: 'border-box'
    }}>
      
      <button
        onClick={onOpenModal}
        style={{
          width: '100%',
          padding: '12px',
          backgroundColor: viewMode === 'shared' ? '#F4A640' : 'transparent',
          color: viewMode === 'shared' ? 'white' : '#F4A640',
          border: viewMode === 'shared' ? 'none' : '2px solid #F4A640',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold',
          marginBottom: '10px'
        }}
      >
        + {viewMode === 'shared' ? '공유' : '개인'} 일정 추가하기
      </button>

      <button 
        onClick={onDeleteSelected}
        style={{ 
          width: '100%',
          padding: '8px',
          backgroundColor: '#fff',
          color: '#E65100',
          border: '1px solid #E65100',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 'bold',
          marginBottom: '20px'
        }}
      >
        선택 항목 삭제
      </button>

      <div>
        <h3 style={{ margin: '0 0 10px 0', fontSize: '16px', color: '#2B2B2B' }}>
          {selectedDate}의 일정 ({currentSchedules.length}개)
        </h3>

        <hr
          style={{
            border: 'none',
            borderTop: '1px solid #EEEEEE',
            marginBottom: '15px'
          }}
        />

        {currentSchedules.length === 0 ? (
          <p style={{ color: '#888888', fontSize: '15px' }}>
            등록된 일정이 없습니다.
          </p>
        ) : (
          <ul style={{ paddingLeft: '0', margin: 0, listStyle: 'none' }}>
            {currentSchedules.map((schedule) => (
              <li 
                key={schedule.id}
                style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  margin: '12px 0',
                  padding: '8px',
                  backgroundColor: '#FFFFFF',
                  borderRadius: '6px',
                  border: '1px solid #F0F0F0',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flex: 1,
                    marginRight: '10px'
                  }}
                >
                  <input 
                    type="checkbox"
                    checked={schedule.completed}
                    onChange={() => onToggleComplete(schedule.id, schedule.completed)}
                    style={{
                      marginRight: '10px',
                      width: '18px',
                      height: '18px',
                      cursor: 'pointer'
                    }}
                  />

                  <span
                    style={{
                      fontSize: '15px',
                      color: schedule.completed ? '#999999' : '#2B2B2B',
                      lineHeight: '1.4',
                      textDecoration: schedule.completed ? 'line-through' : 'none',
                      wordBreak: 'break-all'
                    }}
                  >
                    {schedule.text}
                  </span>
                </div>

                <button 
                  onClick={() => onDeleteSchedule(schedule.id)}
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: '#E65100',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    padding: '4px 8px'
                  }}
                >
                  삭제
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default ScheduleControl;